// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ob-0";
export var discountCodeInput = "_ob-1";